import _createClass from "/opt/build/repo/apps/ac-dealer-portal/node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/apps/ac-dealer-portal/node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
export var ReadyPromise = /*#__PURE__*/_createClass(function ReadyPromise() {
  var _this = this;
  _classCallCheck(this, ReadyPromise);
  this.isReady = false;
  this.isCanceled = false;
  this.promise = new Promise(function (resolve) {
    if (_this.isReady || _this.isCanceled) return resolve();
    _this.resolve = resolve;
  });
  this.ready = function () {
    _this.isReady = true;
    if (_this.resolve) _this.resolve();
  };
  this.cancel = function () {
    _this.isCanceled = true;
    if (_this.resolve) _this.resolve();
  };
  this.then = function (cb, err) {
    if (_this.isCanceled) return _this;
    _this.promise.then(function () {
      if (_this.isCanceled) return;
      cb();
    }, function (e) {
      if (err) err(e);else throw e;
    });
    return _this;
  };
});